/// <amd-module name="Release/Commands/Dialogs/ImportPipelineDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { css } from "VSSUI/Util";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

import { VssComponent, IVssComponentProperties, IVssComponentContext, IVssLayoutManager, Components } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";

import { FileInput, FileInputContentType, FileInputUpdateEventData, FileInputResult } from "VSSUI/FileInput";

import * as Resources from "Release/Commands/Dialogs/Resources";

interface IImportPipelineDialogProps extends IVssComponentProperties {
    onClose: () => void;
    onOkClick: (file: FileInputResult | null) => void;
}

interface IFileInputDialogState {
    file: FileInputResult | null;
    errorMessage: string;
}

class ImportPipelineDialog extends VssComponent<IImportPipelineDialogProps, IFileInputDialogState>{
    public render(): React.ReactNode {
        const state = this.state || { file: null };
        return <Dialog
            titleProps={{ text: Resources.ImportPipelineDialogTitle }}
            onDismiss={this._onDialogClose}
            defaultActiveElement=".vss-FileInput-browseContainer"
            escDismiss={true}
            calloutContentClassName={css("import-dialog release-command-dialog legacy-shim", this.props.className)}
            footerButtonProps={[
                {
                    onClick: this._onDialogClose,
                    text: Resources.Cancel
                },
                {
                    onClick: this._onOkClicked,
                    disabled: !state.file || !!state.errorMessage,
                    primary: true,
                    text: Resources.Ok
                }
            ]}>
            <div>
                {Resources.ImportPipelineDialogText}
                {
                    this.state &&
                    this.state.errorMessage &&
                    < MessageCard severity={MessageCardSeverity.Error} onDismiss={() => this.setState({ errorMessage: "" })} >
                        {this.state.errorMessage}
                    </ MessageCard>
                }

                <FileInput maximumNumberOfFiles={1}
                    maximumSingleFileSize={5 * 1024 * 1024 /* session storage limit in chrome and IE is 5 MB - https://stackoverflow.com/questions/15840976/how-large-is-html5-session-storage */}
                    updateHandler={this._onFileInputUpdate}
                    allowedFileExtensions={["json", "txt"]}
                    resultContentType={FileInputContentType.RawText}
                />

            </div>
        </Dialog>;
    }

    private _closeDialog() {
        if (!!this.props.onClose) {
            this.props.onClose();
        }
    }

    private _onDialogClose = (): void => {
        this._closeDialog();
    }

    private _onOkClicked = (): void => {
        if (!!this.props.onOkClick) {
            this.props.onOkClick(this.state.file);
        }
        this._closeDialog();
    }

    private _onFileInputUpdate = (updateEvent: FileInputUpdateEventData): void => {
        let file: FileInputResult | null = null;
        if (updateEvent && updateEvent.files && updateEvent.files.length) {
            file = updateEvent.files[0].result;
        }

        if (file && file.content) {
            try {
                JSON.parse(file!.content || "");
            }
            catch{
                this.setState({
                    file: null,
                    errorMessage: Resources.ImportDialogInvalidJsonError
                });

                return;
            }
        }

        this.setState({
            file: file,
            errorMessage: ""
        });
    }
}

Components.add("rd-import-dilaog", ImportPipelineDialog);